export default "__VITE_ASSET__f66bdf5b__"